import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let image_series_id = useDataValue({
    context: 'tab',
    path: 'selected.images.image_series_id',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    // used {} to allow metadata = undefined in case of data[0] is undefined
    let { metadata } = data?.[0] || {}

    let iTero = metadata?.find(item => item.name === 'itero')

    return {
      step: 'account',
      account_id: iTero?.preferredAccountId,
      doctor_id: iTero?.preferredDoctorId,
      image_series_id,
      set_preferred: true,
    }
  }, [data, image_series_id])
}
